import { PreloadedQuery } from 'react-relay';

import { pricingPageRelayQuery } from '@/__generated_contentful__/pricingPageRelayQuery.graphql';
import { PricingContentContextProviderRelay } from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { PricingContent } from '@/utils/pricing-queries/get-pricing-content-gql.ts';
import { UserLocale } from '@/utils/useGeoCurrency.ts';

import { AppPricingData } from '../../../../contentful/product-catalog';
import { SoftwareBitbucketPricingPageTemplate } from '../../../../templates/software/bitbucket/pricing/software-bitbucket-pricing-page/src/software-bitbucket-pricing-page.template';

export type SoftwareBitbucketPricingPageProps = {
	pricing?: AppPricingData;
	countryCode?: UserLocale;
	pricingContent?: PricingContent;
	queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const SoftwareBitbucketPricingPage = ({
	pricing,
	countryCode,
	pricingContent,
	queryRef,
}: SoftwareBitbucketPricingPageProps) => {
	return (
		<PricingContentContextProviderRelay
			productId="bitbucket"
			pricingContent={pricingContent}
			queryRef={queryRef}
		>
			<div data-testid="bitbucket-pricing-page">
				<SoftwareBitbucketPricingPageTemplate pricing={pricing} countryCode={countryCode} />
			</div>
		</PricingContentContextProviderRelay>
	);
};
